import { AuthUser, JwtClaims, UserRole } from '@/core/auth/types/auth.types';

export function decodeJwt(token: string): JwtClaims | null {
  const parts = token.split('.');
  if (parts.length !== 3 || !parts[1]) return null;
  try {
    const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = atob(padded.padEnd(padded.length + ((4 - (padded.length % 4)) % 4), '='));
    const claims = JSON.parse(payload) as Partial<JwtClaims>;
    if (
      typeof claims.sub !== 'string' ||
      typeof claims.jti !== 'string' ||
      typeof claims.role !== 'string'
    ) {
      return null;
    }
    return claims as JwtClaims;
  } catch {
    return null;
  }
}

export function claimsToAuthUser(claims: JwtClaims): AuthUser {
  return {
    id: Number(claims.sub),
    role: claims.role.toLowerCase() as UserRole,
    schoolId: claims.school_id != null ? Number(claims.school_id) : null,
    classGroupId: claims.class_group_id != null ? Number(claims.class_group_id) : null,
    jti: claims.jti,
    isTestUser: claims.is_test_user === true,
  };
}

export function isExpired(claims: JwtClaims): boolean {
  if (claims.exp == null) return false;
  return claims.exp * 1000 <= Date.now();
}
